import { React, useState } from "react";
import shortCutImg from "../../../assets/short-cut-img.svg";
import calander from "../../../assets/calander.svg";
import profileSetting from "../../../assets/profile-setting.svg";
import resourceImg from "../../../assets/resource-img.svg";
import { useNavigate } from "react-router-dom";
import UploadMeetingAndAttendance from "../../Model/uploadMeetingAndAttendance";
import CronModel from "../../Model/UploadCronFile";
import UploadUsers from "../../Model/UploadUsers";
export default function DashboardShortCuts({ type }) {
  const navigate = useNavigate();
  const userInfo = JSON.parse(localStorage.getItem("loggedInUserInfo") || "{}");
  const userType = userInfo.user_type;
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showUploadCronModal, setShowUploadCronModal] = useState(false);
  const [showUploadUsers, setShowUploadUsers] = useState(false);


  return (
    <>
      <div className="col-12 col-md-4">
        <div className="card w-100 h-100 bg-white rounded-3 shadow-sm mb-4 border-0">
          <div className="card-header g-0 m-0 p-0 overflow-hidden border-bottom border-light border-2">
            <div className="row g-0">
              <div className="col g-0">
                <h3 className="p-3 mb-0 pb-0 point-22 text-uppercase text-primary fw-bold">
                  Short Cuts
                </h3>
              </div>
              <div className="col-auto bg-secondary">
                <div className="rounded-pill bg-secondary w-100">
                  <div className="d-flex flex-column justify-content-center">
                    <img
                      src={shortCutImg}
                      alt="logo"
                      className="header-icon m-2"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="card-body p-3"
            style={{ maxHeight: "300px", overflowY: "auto" }}
          >
            {" "}
            {/* Added style here */}
            <div className="">
              <div className="container-fluid">
                {(userType && userType?.toUpperCase() !== "CCN_INTERNAL") ||
                  (type != "CCN" && (
                    <div className="row mb-4 g-2">
                      <div className="col-2">
                        <div className="text-left">
                          <div className="rounded-pill bg-secondary ratio ratio-1x1 w-100">
                            <div className="d-flex flex-column justify-content-center">
                              <div className="text-white fw-bold text-center text-uppercase point-10">
                                <img
                                  src={calander}
                                  alt="icon"
                                  className="w-50"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col text-primary text-uppercase fw-bold point-18">
                        <div className="h-100 d-flex align-items-center cursor-pointer">
                          <div
                            className="align-middle"
                            onClick={() => navigate("/calander")}
                          >
                            My Calendar
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}


                <div className="row mb-4 g-2">
                  <div className="col-2">
                    <div className="text-left">
                      <div className="rounded-pill bg-secondary ratio ratio-1x1 w-100">
                        <div className="d-flex flex-column justify-content-center">
                          <div className="text-white fw-bold text-center text-uppercase point-10">
                            <img
                              src={profileSetting}
                              alt="icon"
                              className="w-50"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col text-primary text-uppercase fw-bold point-18">
                    <div className="h-100 d-flex align-items-center cursor-pointer">
                      <div
                        className="align-middle"
                        onClick={() => navigate("/profile")}
                      >
                        Profile Settings
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-4 g-2">
                  <div className="col-2">
                    <div className="text-left">
                      <div className="rounded-pill bg-secondary ratio ratio-1x1 w-100">
                        <div className="d-flex flex-column justify-content-center">
                          <div className="text-white fw-bold text-center text-uppercase point-10 text-white">
                            <img
                              src={resourceImg}
                              alt="icon"
                              className="w-50"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col text-primary text-uppercase fw-bold point-18">
                    <div className="h-100 d-flex align-items-center cursor-pointer">
                      <div
                        className="align-middle"
                        onClick={() => navigate("/forms")}
                      >
                        Resources
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-4 g-2">
                  <div className="col-2">
                    <div className="text-left">
                      <div className="rounded-pill bg-secondary ratio ratio-1x1 w-100">
                        <div className="d-flex flex-column justify-content-center">
                          <div className="text-white fw-bold text-center text-uppercase point-10 text-white">
                            <img
                              src={resourceImg}
                              alt="icon"
                              className="w-50"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col text-primary text-uppercase fw-bold point-18">
                    <div className="h-100 d-flex align-items-center cursor-pointer">
                      <div
                        className="align-middle"
                        onClick={() => navigate("/myprojects")}
                      >
                        My Projects
                      </div>
                    </div>
                  </div>
                </div>

                {userType &&
                  userType?.toUpperCase() === "CCN_INTERNAL" &&
                  type === "CCN" && (
                    <div className="row mb-4 g-2">
                      <div className="col-2">
                        <div className="text-left">
                          <div className="rounded-pill bg-secondary ratio ratio-1x1 w-100">
                            <div className="d-flex flex-column justify-content-center">
                              <div className="text-white fw-bold text-center text-uppercase point-10 text-white">
                                <img
                                  src={resourceImg}
                                  alt="icon"
                                  className="w-50"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col text-primary text-uppercase fw-bold point-18">
                        <div className="h-100 d-flex align-items-center cursor-pointer">
                          <div
                            className="align-middle"
                            onClick={() => window.open("https://imsoidc.bentley.com/connect/authorize?client_id=projectwise-365&redirect_uri=https%3A%2F%2Fprojectwise365.bentley.com%2Fsignin-oidc.html&response_type=code&scope=openid%20profile%20organization%20global_roles%20feature_tracking%20email%20context-registry-service%20forms-data-access-2346%20projectwise-deliverables-management-service%20rbac-service%20provision-service%20scs%3Aread-supply-chain%20scs%3Amanage-supply-chain%20product-settings-service%20context-entitlement-service-2924%20repository-federation-2567%20projectwise-documents-2766%20imodelhub%20synchro-4d-review-api%20projectwise-review-2892%20cloud-orchestration-service-2566%20projectwise-365-portal%20projectwise-share%20token-store-3014%20pwic%3Amanage%20agreements-2354%20sso%3A%2F%2Fpw-integration-server%2F1016%20imodel-bridge-service-api-general%20imodels%3Aread%20imodels%3Amodify%20projectwise-web-connections-service%20projectwise-drive-settings-api%20office-365-collaboration-service%20projectwise-imodel-publishing%20projectwise-user-sync-api%20projects%3Aread%20projects%3Amodify%20map-layer%20projectwise-token-exchange&state=1e811354cb154674b56a0b1639836684&code_challenge=OUcmdRvgeklMIqN5jZKsHZwmD1lHcsSrxEcHZEhYJTc&code_challenge_method=S256&response_mode=query", "_blank")}
                          >
                            Projectwise
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                {userType &&
                  userType?.toUpperCase() === "CCN_INTERNAL" &&
                  type === "CCN" && (
                    <div className="row mb-4 g-2">
                      <div className="col-2">
                        <div className="text-left">
                          <div className="rounded-pill bg-secondary ratio ratio-1x1 w-100">
                            <div className="d-flex flex-column justify-content-center">
                              <div className="text-white fw-bold text-center text-uppercase point-10 text-white">
                                <img
                                  src={resourceImg}
                                  alt="icon"
                                  className="w-50"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col text-primary text-uppercase fw-bold point-18">
                        <div className="h-100 d-flex align-items-center cursor-pointer">
                          <div
                            className="align-middle"
                            onClick={() => setShowUploadModal(true)}
                          >
                            Upload Meetings and Attendance Records
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                {userType &&
                  userType?.toUpperCase() === "CCN_INTERNAL" &&
                  type === "CCN" && (
                    <div className="row mb-4 g-2">
                      <div className="col-2">
                        <div className="text-left">
                          <div className="rounded-pill bg-secondary ratio ratio-1x1 w-100">
                            <div className="d-flex flex-column justify-content-center">
                              <div className="text-white fw-bold text-center text-uppercase point-10 text-white">
                                <img
                                  src={resourceImg}
                                  alt="icon"
                                  className="w-50"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col text-primary text-uppercase fw-bold point-18">
                        <div className="h-100 d-flex align-items-center cursor-pointer">
                          <div
                            className="align-middle"
                            onClick={() => setShowUploadCronModal(true)}
                          >
                            Cron/Sycn File Upload
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                {userType &&
                  userType?.toUpperCase() === "CCN_INTERNAL" &&
                  type === "CCN" && (
                    <div className="row mb-4 g-2">
                      <div className="col-2">
                        <div className="text-left">
                          <div className="rounded-pill bg-secondary ratio ratio-1x1 w-100">
                            <div className="d-flex flex-column justify-content-center">
                              <div className="text-white fw-bold text-center text-uppercase point-10 text-white">
                                <img
                                  src={resourceImg}
                                  alt="icon"
                                  className="w-50"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col text-primary text-uppercase fw-bold point-18">
                        <div className="h-100 d-flex align-items-center cursor-pointer">
                          <div className="h-100 d-flex align-items-center cursor-pointer" onClick={() => setShowUploadUsers(true)}>

                            Upload Users
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                {/* {userType &&
                  userType?.toUpperCase() === "CCN_INTERNAL" &&
                  type === "CCN" && (
                    <div className="row mb-4 g-2">
                      <div className="col-2">
                        <div className="text-left">
                          <div className="rounded-pill bg-secondary ratio ratio-1x1 w-100">
                            <div className="d-flex flex-column justify-content-center">
                              <div className="text-white fw-bold text-center text-uppercase point-10 text-white">
                                <img
                                  src={resourceImg}
                                  alt="icon"
                                  className="w-50"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col text-primary text-uppercase fw-bold point-18">
                        <div className="h-100 d-flex align-items-center cursor-pointer">
                          <div
                            className="align-middle"
                            onClick={() => navigate("/mapped_specialities")}
                          >
                            Mapped Specialities
                          </div>
                        </div>
                      </div>
                    </div>
                  )} */}
                {/* {userType &&
                  userType?.toUpperCase() === "CCN_INTERNAL" &&
                  type === "CCN" && (
                    <div className="row mb-4 g-2">
                      <div className="col-2">
                        <div className="text-left">
                          <div className="rounded-pill bg-secondary ratio ratio-1x1 w-100">
                            <div className="d-flex flex-column justify-content-center">
                              <div className="text-white fw-bold text-center text-uppercase point-10 text-white">
                                <img
                                  src={resourceImg}
                                  alt="icon"
                                  className="w-50"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col text-primary text-uppercase fw-bold point-18">
                        <div className="h-100 d-flex align-items-center cursor-pointer">
                          <div
                            className="align-middle"
                            onClick={() => navigate("/wah")}
                          >
                            WAH Dashboard
                          </div>
                        </div>
                      </div>
                    </div>
                  )} */}

                {/* {userType &&
                  userType?.toUpperCase() === "CCN_INTERNAL" &&
                  type === "CCN" && (
                    <div className="row mb-4 g-2">
                      <div className="col-2">
                        <div className="text-left">
                          <div className="rounded-pill bg-secondary ratio ratio-1x1 w-100">
                            <div className="d-flex flex-column justify-content-center">
                              <div className="text-white fw-bold text-center text-uppercase point-10 text-white">
                                <img
                                  src={resourceImg}
                                  alt="icon"
                                  className="w-50"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col text-primary text-uppercase fw-bold point-18">
                        <div className="h-100 d-flex align-items-center cursor-pointer">
                          <div
                            className="align-middle"
                            onClick={() => navigate("/dashboard")}
                          >
                            Suscription Dashboard
                          </div>
                        </div>
                      </div>
                    </div>
                  )} */}

                {/* {userType &&
                  userType?.toUpperCase() === "CCN_INTERNAL" &&
                  type === "CCN" && (
                    <div className="row mb-4 g-2">
                      <div className="col-2">
                        <div className="text-left">
                          <div className="rounded-pill bg-secondary ratio ratio-1x1 w-100">
                            <div className="d-flex flex-column justify-content-center">
                              <div className="text-white fw-bold text-center text-uppercase point-10 text-white">
                                <img
                                  src={resourceImg}
                                  alt="icon"
                                  className="w-50"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col text-primary text-uppercase fw-bold point-18">
                        <div className="h-100 d-flex align-items-center cursor-pointer">
                          <div
                            className="align-middle"
                            onClick={() => navigate("/MRB_dashboard")}
                          >
                            MRB Dashboard
                          </div>
                        </div>
                      </div>
                    </div>
                  )} */}

                {userType &&
                  userType?.toUpperCase() === "CCN_INTERNAL" &&
                  type === "CCN" && (
                    <div className="row mb-4 g-2">
                      <div className="col-2">
                        <div className="text-left">
                          <div className="rounded-pill bg-secondary ratio ratio-1x1 w-100">
                            <div className="d-flex flex-column justify-content-center">
                              <div className="text-white fw-bold text-center text-uppercase point-10 text-white">
                                <img
                                  src={resourceImg}
                                  alt="icon"
                                  className="w-50"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col text-primary text-uppercase fw-bold point-18">
                        <div className="h-100 d-flex align-items-center cursor-pointer">
                          <div
                            className="align-middle"
                            onClick={() => navigate('/agency_report')}
                          >
                            AGENCY REPORT
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {showUploadModal && (
        <UploadMeetingAndAttendance
          show={showUploadModal}
          onClose={() => setShowUploadModal(false)}
        />
      )}
      {showUploadCronModal && (
        <CronModel
          show={showUploadCronModal}
          onClose={() => setShowUploadCronModal(false)}
        />
      )}
      {showUploadUsers && (
        <UploadUsers
          show={showUploadUsers}
          onClose={() => setShowUploadUsers(false)}
        />
      )}
    </>
  );
}
